import { parseSelection } from "../../parseSelection";
import { parseSettlementStatus } from "../../parseSettlementStatus";
import { safeString, isSettlementStatusVoid } from "../../../helpers";
const winningStatuses = ["Won", "CashOut", "DeadHeatReduction"];
export function parseSelections({ selections, events, teamLogos, dateFormatter, dict, staticS3Host, swooshFeatureFlag, swooshBaseUrl }) {
    const isAllEventTheSame = selections.every(selection => selection.eventId === selections[0].eventId);
    const result = selections.reduce((acc, selection, index) => {
        const isLastInEventGroup = index === selections.length - 1 || selections[index + 1].eventId !== selection.eventId;
        const s = parseSelection(selection, events, teamLogos, dateFormatter, dict, staticS3Host, swooshFeatureFlag, swooshBaseUrl, isAllEventTheSame, isLastInEventGroup);
        return {
            valid: acc.valid && typeof s !== "undefined",
            selections: typeof s !== "undefined" ? [...acc.selections, s] : acc.selections,
        };
    }, {
        valid: true,
        selections: [],
    });
    return result.valid ? result.selections : [];
}
export function parseCombinations({ selections, combinations, dictionary, formatAmount }) {
    const selectionsMapped = new Map();
    selections.forEach((selection, index) => {
        selectionsMapped.set(selection.selectionId, {
            status: selection.status,
            id: `${index + 1}`
        });
    });
    return combinations.map(combination => ({
        id: combination.id,
        returns: parseCombinationReturns({ combination, dictionary, formatAmount }),
        status: parseSettlementStatus(combination.status),
        selectionsMapped: combination.selectionsMapped.map(selectionId => {
            const mapped = selectionsMapped.get(selectionId);
            return {
                status: safeString(mapped === null || mapped === void 0 ? void 0 : mapped.status),
                id: safeString(mapped === null || mapped === void 0 ? void 0 : mapped.id),
            };
        }),
    }));
}
function parseCombinationReturns({ combination, dictionary, formatAmount, }) {
    if (combination.status === "Lost") {
        return dictionary.myBetsDictionary.Lost;
    }
    return formatAmount(combination.potentialReturns, "");
}
export function parseBetEnhancedType(selections) {
    const isSGPExtra = selections.some(s => typeof s.nestedSGPSelections !== "undefined");
    return isSGPExtra ? "SGPExtra" : "None";
}
export const getSelectionsLength = (selections) => {
    let selectionsLength = 0;
    selections.forEach(selection => {
        var _a;
        selectionsLength = selectionsLength + (((_a = selection.nestedSGPSelections) === null || _a === void 0 ? void 0 : _a.length) || 1);
    });
    return selectionsLength;
};
export const getIconStatus = (lostSelections, wonSelections, activeSelections, numberOfSelections) => {
    if (numberOfSelections === wonSelections) {
        return "WINNING";
    }
    else if (numberOfSelections < wonSelections) {
        return "WON";
    }
    else if (activeSelections - lostSelections < numberOfSelections) {
        return "LOST";
    }
    else {
        return "EMPTY";
    }
};
export const buildProgressiveParlayTable = (bet, dictionary, formatAmount) => {
    let progressiveParyalRows = [];
    const activeSelections = bet.selections.filter(selection => !isSettlementStatusVoid(parseSettlementStatus(selection.settlementStatus)));
    const DEFAULT_VALUE_ODDS = 1;
    if (bet.progressiveParlay && bet.settlementStatus !== "Cancelled" && activeSelections.length > 2) {
        const wonSelections = activeSelections.filter(selection => winningStatuses.includes(selection.settlementStatus)).length;
        const lostSelections = activeSelections.filter(selection => selection.settlementStatus === "Lost").length;
        const minimumLegs = bet.progressiveParlay[bet.progressiveParlay.length - 1].numberOfSelections;
        progressiveParyalRows = [
            ...bet.progressiveParlay.map(({ numberOfSelections, displayOdds, returns, trueOdds }, index) => ({
                label: index === 0 ? dictionary.myBetsDictionary.ProgressiveParlayMaxWin.replace("{0}", numberOfSelections.toString()) : dictionary.myBetsDictionary.ProgressiveParlayPossibleWin.replace("{0}", numberOfSelections.toString()).replace("{1}", activeSelections.length.toString()),
                status: getIconStatus(lostSelections, wonSelections, activeSelections.length, numberOfSelections),
                displayOdds: trueOdds <= DEFAULT_VALUE_ODDS ? dictionary.myBetsDictionary.ReturnWager : displayOdds,
                returns: formatAmount(returns, "").trim()
            })),
            {
                label: dictionary.myBetsDictionary.ProgressiveParlayLost.replace("{0}", minimumLegs.toString()),
                status: "NONE",
                displayOdds: "-",
                returns: dictionary.myBetsDictionary.ProgressiveParlayLostReturns
            }
        ];
    }
    return {
        headers: [dictionary.myBetsDictionary.ProgressiveParlayOutcomeHeader, dictionary.myBetsDictionary.ProgressiveParlayOddsHeader, dictionary.myBetsDictionary.ProgressiveParlayPayoutHeader],
        rows: progressiveParyalRows
    };
};
//# sourceMappingURL=utils.js.map